import Experience from './experience/Experience.js'
import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'
import { works } from './data/works.js'

import 'swiper/css'

const experience = new Experience(document.querySelector('canvas.webgl'), document.querySelector('#canvas-container'))

// Render work cards
const cardList = document.querySelector('.card-list')
works.forEach(work => {
  const li = document.createElement('li')
  li.className = 'card-item swiper-slide'

  const a = document.createElement('a')
  a.className = 'card-link'
  a.href = work.href
  a.target = '_blank'
  a.rel = 'noopener noreferrer'

  const img = document.createElement('img')
  img.className = 'card-image'
  img.src = work.image
  img.alt = work.imageAlt
  img.loading = 'lazy'

  const badgesDiv = document.createElement('div')
  badgesDiv.className = 'card-badges'
  work.badges.forEach(badge => {
    const p = document.createElement('p')
    p.className = `badge ${badge.type}`
    p.textContent = badge.label
    badgesDiv.appendChild(p)
  })

  const h2 = document.createElement('h2')
  h2.className = 'card-title'
  h2.textContent = work.title

  const p = document.createElement('p')
  p.className = 'card-paragraph'
  p.textContent = work.description

  const btn = document.createElement('span')
  btn.className = 'card-button material-symbols-rounded'
  btn.setAttribute('aria-hidden', 'true')
  btn.textContent = 'arrow_forward'

  a.append(img, badgesDiv, h2, p, btn)
  li.appendChild(a)
  cardList.appendChild(li)
})

// Sidebar events
const sidebarButton = document.querySelector('#header-sidebar-button')
const sidebar = document.querySelector('#sidebar-container')
const sidebarLinks = document.querySelectorAll('.sidebar-item')
const sidebarSlideAnimationDuration = getTransitionDurationMS(sidebar) ?? 300

sidebarButton.addEventListener('click', () => {
  sidebar.classList.toggle('close')
})

sidebarLinks.forEach(link => {
  link.addEventListener('click', e => {
    e.preventDefault() // blocco subito il redirect

    sidebar.classList.add('close')

    const targetHref = link.getAttribute('href')
    const target = document.querySelector(targetHref)
    if (!target) return

    setTimeout(() => {
      target.scrollIntoView({
        behavior: 'smooth', // smooth scroll
        block: 'center' // allinea in cima alla viewport
      })
    }, sidebarSlideAnimationDuration)
  })
})

// Swiper settings
const swiper = new Swiper('.swiper', {
  loop: true,
  spaceBetween: 30,
  modules: [Navigation, Pagination],

  // If we need pagination
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
    dynamicBullets: true
  },

  // Navigation arrows
  navigation: {
    nextEl: '#slider-button-next',
    prevEl: '#slider-button-prev'
  },

  breakpoints: {
    '@0.0': {
      slidesPerView: 1
    },
    '@1.2': {
      slidesPerView: 3
    }
  }
})

// Replace with your form endpoint (e.g. 'https://formsubmit.co/your@email.com' or 'https://formspree.io/f/your-id')
const CONTACT_FORM_ENDPOINT = ''

function setupContactForm() {
  const form = document.querySelector('#contact-section form')
  if (!form) return

  const submitBtn = form.querySelector('button[type="submit"]')
  const feedback = document.createElement('p')
  feedback.className = 'form-feedback'
  form.querySelector('.submit-group').prepend(feedback)

  form.addEventListener('submit', async e => {
    e.preventDefault()

    if (!CONTACT_FORM_ENDPOINT) {
      console.warn('[Contact] CONTACT_FORM_ENDPOINT is not configured in script.js')
      return
    }

    submitBtn.disabled = true
    submitBtn.textContent = 'Sending…'
    feedback.className = 'form-feedback'
    feedback.textContent = ''

    try {
      const res = await fetch(CONTACT_FORM_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          name: form.name.value.trim(),
          email: form.email.value.trim(),
          message: form.message.value.trim()
        })
      })

      if (!res.ok) throw new Error(`HTTP ${res.status}`)

      form.reset()
      feedback.className = 'form-feedback form-feedback--success'
      feedback.textContent = "Message sent! I'll get back to you soon."
    } catch {
      feedback.className = 'form-feedback form-feedback--error'
      feedback.textContent = 'Something went wrong. Please try again or reach out via email.'
    } finally {
      submitBtn.disabled = false
      submitBtn.textContent = 'Send Message'
    }
  })
}

setupContactForm()

function getTransitionDurationMS(element) {
  const durationStr = getComputedStyle(element).getPropertyValue('transition-duration').trim()

  if (!durationStr) return 300

  // possono esserci più valori separati da virgola (uno per proprietà)
  const first = durationStr.split(',')[0].trim()

  if (first.endsWith('ms')) {
    return parseFloat(first)
  } else if (first.endsWith('s')) {
    return parseFloat(first) * 1000
  }
  return parseFloat(first) || 0
}
